<!-- eslint-disable -->
<template lang="pug">
    .drop-box(v-if="answers.length || gameStarted", :class="{'drop-box--large': itemsLength <= 3\}")
        .drop-box__shadow.drop-box__shadow_left
            svg-icon.drop-box__arrow-icon(
                name="angle-left",
                :height='customIconSizes.height',
                :width="customIconSizes.width"
            )
        .answers-container(
            v-if="gameMode !== 'inTurn' || gameStarted"
            @wheel='handleScrollOfBox'
        )
            .flip-div
                .link(
                    v-for="(item, index) in answers",
                    :key='index'
                )
                    drag(
                        class="answers-container__drag",
                        v-if="linksType === 'image' && item.type !== 'dropZone'"
                        :draggable="gameStarted && item.type !== 'correct-link'"
                        :transfer-data="{ item: item, index: index, from: 'answers-box'}"
                        @dragstart="$emit('dragStarted')"
                        @dragend="$emit('dragEnded')"
                    )
                        img(
                            class="answer"
                            :class="{\
                                'answer_correct': item.type === 'correct-link',\
                                'answer--large': itemsLength <= 3\
                            }",
                            :src='item.value | apiFile',
                            :data-index='index'
                            :draggable="gameStarted && item.type !== 'correct-link'"
                        )
        .drop-box__shadow.drop-box__shadow_right
            svg-icon.drop-box__arrow-icon(
                name="angle-right",
                :height='customIconSizes.height',
                :width="customIconSizes.width"
            )
</template>

<script>
    /*eslint-disable*/
    import { Drag, Drop } from 'vue-drag-drop';
    const DEFAULT_VOLUME = 0.6;

    export default {
        props: {
            answers: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            gameStarted: Boolean,
            gameMode: String,
            linksType: String,
            dragStarted: Boolean,
            helperModeOn: Boolean,
            itemsLength: {
                type: Number,
                default: 3
            }
        },
        data () {
            return {
                showingIndex: 0,
                soundInstance: null,
                isInputFocused: false,
            }
        },
        watch: {
            dragStarted (value) {
                let shakeZone = document.querySelectorAll('.drop-zone__shake-zone');
                let amount = shakeZone.length;
                let timeouts = [];
                if (value && shakeZone) {
                    for (let i = 0; i < amount; i++) {
                        timeouts.push(setTimeout(() => {
                            shakeZone[i].classList.add('shake');
                        }, i * 100));
                    }
                    setTimeout(() => {
                        for(let j = 0; j < timeouts.length; j++) {
                            clearTimeout(timeouts[j]);
                        }
                        for (let i = 0; i < amount; i++) {
                            if (shakeZone[i]) {
                                shakeZone[i].classList.remove('shake');
                            }
                        }
                    }, 2000)
                }
            }
        },
        updated () {
            this.isInputFocused = this.helperModeOn === true ? false : this.isInputFocused;
            if (!this.isInputFocused && this.$refs.input && this.$refs.input[0]) {
                this.$refs.input[0].blur();
                this.focusNextElement();
            }
        },
        methods: {
            handleScrollOfBox (e) {
                e = window.event || e;
                let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
                let className = '.answers-container';
                document.querySelector(className).scrollLeft -= (delta * 65);
                e.preventDefault();
            },
            focusInput (event) {
                this.isInputFocused = this.$refs.input.some(element => _.isEqual(element, event.target));
            },
            focusNextElement(index = 0) {
                let uncompletedItems = this.answers.filter(item => item.type === "textInput");
                let completedItems = this.answers.filter((item, itemIndex) => item.type !== "textInput" && itemIndex < index);
                index = index - completedItems.length;
                index = index >= uncompletedItems.length ? index % uncompletedItems.length : index;
                let isChainCompleted = !this.answers.some(item => item.value === '');
                if (isChainCompleted) {
                    this.isInputFocused = false;
                    this.$emit('processReply');
                } else if (this.$refs.input[index]) {
                    this.$refs.input[index].focus();
                }
            },
        },
        computed: {
            itemValue () {
                return this.answers[this.showingIndex].value;
            },
            customIconSizes () {
                const windowWidth = window.innerWidth;
                if (windowWidth < 576) {
                    return  {height: '19px', width: '12px'};
                } else if (windowWidth < 992) {
                    return  {height: '26px', width: '16px'};
                }
                return  {height: '32px', width: '20px'};
            },
        },
        components: {
            Drag,
            Drop
        }
    }
</script>

<style lang="scss" scoped>
    .link {
        display: inline-flex;
    }

    .link:last-child .answer {
        margin-right: 10px;
    }

    .link-icon {
        width: 50px;
    }

    .link-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .drop-box {
        position: relative;
        display: flex;
        align-items: center;
        min-height: 110px;
        min-width: 150px;
        max-width: 340px;
        @include media($sm) {
            min-height: 130px;
            min-width: 180px;
            max-width: 420px;
        }
        @include media($md) {
            min-height: 195px;
            min-width: 295px;
            max-width: 100%;
        }
        @include media($lg) {
            min-height: 240px;
            min-width: 340px;
        }
        @include media($xlg) {
            min-height: 175px;
            min-width: 275px;
        }
        @include media($xl) {
            min-height: 230px;
            min-width: 330px;
        }
        @include media($xxl) {
            min-width: 215px;
            min-height: 275px;
        }
    }

    .drop-box--large {
        min-height: 110px;
        min-width: 160px;
        @include media($sm) {
            min-height: 145px;
            min-width: 205px;
        }
        @include media($md) {
            min-height: 195px;
            min-width: 305px;
        }
        @include media($lg) {
            min-height: 240px;
            min-width: 350px;
        }
        @include media($xlg) {
            min-height: 215px;
            min-width: 325px;
        }
        @include media($xl) {
            min-height: 240px;
            min-width: 350px;
        }
        @include media($xxl) {
            min-height: 305px;
            min-width: 415px;
        }
    }

    .drop-box__shadow {
        top: 4px;
        display: flex;
        align-items: center;
        position: absolute;
        z-index: 100;
        height: calc(100% - 4px);
    }

    .drop-box__shadow_right {
        right: 0;
        padding-right: 14px;
        justify-content: flex-end;
        background: linear-gradient(to right, transparent, white);
        border-radius: 0 $border-radius-10 $border-radius-10 0;
        @include media($md) {
            padding-right: 30px;
        }
    }

    .drop-box__shadow_left {
        left: 0;
        padding-left: 14px;
        justify-content: flex-start;
        background: linear-gradient(to left, transparent, white);
        border-radius: $border-radius-10 0 0 $border-radius-10;
        @include media($md) {
            padding-left: 30px;
        }
    }

    .drop-box__arrow-icon {
        color: $hsl-color-blue-56;
    }

    .drop-zone {
        display: inline-flex;
    }

    .drop-zone__shake-zone {
        width: 200px;
        height: 200px;
        margin: auto;
        background: white;
        border: 1px solid $hsl-color-green-58;
        border-radius: 12px;
    }

    .answers-container {
        box-sizing: border-box;
        background-color: white;
        border-radius: $border-radius-10;
        border: 1px solid $color-grey-300;
        border-left: none;
        border-right: none;
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-x: auto;
        white-space: nowrap;
        user-select: none;
        text-align: center;
        transform: rotateX(180deg);
        &::-webkit-scrollbar-track, &::-webkit-scrollbar-track {
            background: #E6E6F8;
        }
        &::-webkit-scrollbar, &::-webkit-scrollbar {
            background-color: #E6E6F8;
            height: 4px;
        }
        &::-webkit-scrollbar-thumb, &::-webkit-scrollbar-thumb {
            height: 4px;
            background: #C1C1F2;
        }
        padding: 10px 0;
        @include media($md) {
            padding: 20px 0;
        }
    }

    .answers-container:not(:first-child) {
        padding-left: 28px;
        @include media($md) {
            padding-left: 60px;
        }
    }

    .answers-container:not(:last-child) {
        padding-right: 28px;
        @include media($md) {
            padding-right: 60px;
        }
    }

    .flip-div {
        height: 100%;
        width: 100%;
        transform: rotateX(180deg);
    }

    .answers-container__drag {
        display: inline-flex;
    }

    .answer {
        display: inline-block;
        vertical-align: middle;
        border: 1px solid $color-grey-600;
        border-radius: 12px;
        margin-left: 10px;
        cursor: grab;
        max-height: 90px;
        max-width: 90px;
        @include media($sm) {
            max-height: 110px;
            max-width: 110px;
        }
        @include media($md) {
            max-height: 155px;
            max-width: 155px;
        }
        @include media($lg) {
            max-height: 200px;
            max-width: 200px;
            margin-left: 20px;
        }
        @include media($xlg) {
            max-height: 135px;
            max-width: 135px;
            margin-left: 10px;
        }
        @include media($xl) {
            max-height: 190px;
            max-width: 190px;
            margin-left: 20px;
        }
        @include media($xxl) {
            max-height: 155px;
            max-width: 155px;
        }
    }

    .answer--large {
        max-height: 90px;
        max-width: 90px;
        @include media($sm) {
            max-height: 120px;
            max-width: 120px;
        }
        @include media($md) {
            max-height: 155px;
            max-width: 155px;
        }
        @include media($lg) {
            max-height: 200px;
            max-width: 200px;
        }
        @include media($xlg) {
            max-height: 175px;
            max-width: 175px;
        }
        @include media($xl) {
            max-height: 200px;
            max-width: 200px;
        }
        @include media($xxl) {
            max-height: 265px;
            max-width: 265px;
        }
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
